/**
 * FAQ Accordion Script
 * Enhances the functionality of FAQ accordions in collection pages
 */
document.addEventListener('DOMContentLoaded', () => {
  const faqSection = document.querySelector('.faq-section');
  if (!faqSection) return;

  // Add accessibility attributes
  const tabs = faqSection.querySelectorAll('.tab');
  tabs.forEach((tab, index) => {
    const input = tab.querySelector('input');
    const label = tab.querySelector('.tab__label');
    const content = tab.querySelector('.tab__content');
    
    if (!input || !label || !content) return;
    
    // Add ARIA attributes
    const id = `faq-content-${index}`;
    content.id = id;
    label.setAttribute('aria-expanded', 'false');
    label.setAttribute('aria-controls', id);
    content.setAttribute('aria-hidden', 'true');
    
    // Add click event listener for keyboard navigation
    input.addEventListener('change', () => {
      const isChecked = input.checked;
      label.setAttribute('aria-expanded', isChecked ? 'true' : 'false');
      content.setAttribute('aria-hidden', isChecked ? 'false' : 'true');
    });
    
    // Add keyboard support
    label.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        input.checked = !input.checked;
        
        // Trigger the change event manually
        const event = new Event('change');
        input.dispatchEvent(event);
      }
    });
  });
  
  // Auto-open first item (optional, comment out if not needed)
  // if (tabs.length > 0) {
  //   const firstInput = tabs[0].querySelector('input');
  //   if (firstInput) {
  //     firstInput.checked = true;
  //     firstInput.dispatchEvent(new Event('change'));
  //   }
  // }
});